import React, { useEffect, useState } from 'react';
import {useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fetchAppInfo } from '../../network/service';
import { ToastContainer, toast } from "react-toastify";
import aboutNewvibeImg from '../../assets/Images/newvibe_about.jpg';

const About = () => {

  const projectInfo = useSelector((state) => state?.projectInfo?.value);

  const navigate = useNavigate();

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  return (
    <div className="aboutUsNewvibe">
      <ToastContainer />
      <div className="aboutContainer">
        <div className="imageWrapper">
          <img
            src={aboutNewvibeImg}
            alt="AboutUs"
            className="aboutNewvibe-img"
          />        
          <div
            className="subscribe-overlay"
            onClick={() => {
              if (projectInfo?.projectConfig?.config?.WEBSITE_NEW_CHECKOUT_REQUIRED === "true") {
                navigate("/checkout", { });
              } else {
                navigate("/subscription", { });
              }
            }}
          >
          </div>
           
        </div>
      </div>
    </div>
  );
};

export default About;
